
import { useState } from "react";

/**
 * Hook that manages the state for Slack integration settings
 */
export const useSettingsState = (initialValues?: {
  webhookUrl?: string;
  slackToken?: string;
  triggerTag?: string;
  isFileProcessingEnabled?: boolean;
  isAutoResponsesEnabled?: boolean;
  isRoleDetectionEnabled?: boolean;
}) => {
  const [webhookUrl, setWebhookUrl] = useState(initialValues?.webhookUrl || "");
  const [slackToken, setSlackToken] = useState(initialValues?.slackToken || "");
  const [triggerTag, setTriggerTag] = useState(initialValues?.triggerTag || "@VirtuStaff");
  const [isFileProcessingEnabled, setIsFileProcessingEnabled] = useState(
    initialValues?.isFileProcessingEnabled !== undefined ? initialValues.isFileProcessingEnabled : true
  );
  const [isAutoResponsesEnabled, setIsAutoResponsesEnabled] = useState(
    initialValues?.isAutoResponsesEnabled !== undefined ? initialValues.isAutoResponsesEnabled : true
  );
  const [isRoleDetectionEnabled, setIsRoleDetectionEnabled] = useState(
    initialValues?.isRoleDetectionEnabled !== undefined ? initialValues.isRoleDetectionEnabled : true
  );

  return {
    webhookUrl,
    setWebhookUrl,
    slackToken,
    setSlackToken,
    triggerTag,
    setTriggerTag,
    isFileProcessingEnabled,
    setIsFileProcessingEnabled,
    isAutoResponsesEnabled,
    setIsAutoResponsesEnabled,
    isRoleDetectionEnabled,
    setIsRoleDetectionEnabled
  };
};
